import styled from 'styled-components';
import Theme from 'utils/theme';

export const LoginWrapper = styled.div`
  height: 100%;
  width: 100%;
  & .flexi-login-splitlayout {
    min-width: 100%;
    & .flexi-login-left {
      border-radius: 0 0 45px 0;
      box-shadow: none;
      & img {
        border-radius: 15px 0 15px 0;
        width: 90%;
        /* transform: translate(30px, 20px); */
      }
    }
    & .flexi-login-right {
      max-width: 100%;
      overflow-x: hidden;
      box-shadow: none;
      background: linear-gradient(to bottom, #fff, ${Theme.PrimaryFade});
      & .flexi-login-right-top {
        & img {
          height: 100%;
          max-height: 100px;
        }
      }
    }
  }

  .reset-it {
    cursor: pointer;
  }
`;
